import React, {
  useState, useEffect, useContext, useMemo,
} from 'react';
import { Avatar, Box, Grid } from '@material-ui/core';

import { useTheme, makeStyles } from '@material-ui/styles';
import { func } from 'prop-types';

import { useError, Typography, Button } from '@avon/component-library';

import { InlineShareButtons } from 'sharethis-reactjs';
import cookies from 'react-cookies';

import dayjs from 'dayjs';
import { compareAsc } from 'date-fns';
import {
  getLeadsByStatus, getViewAllLeads, getOptOut,
} from '../../utils/api/endpoints';
import { isDesktop, isMobile, isTablet } from '../../utils/getDeviceType';

import Timer from '../Timer';
import HomeContext from '../../home/HomeContext';

import infoSvg from '../../styles/assets/info.svg';
import closeSvg from '../../styles/assets/close_white.svg';

const useStyles = makeStyles(() => ({
  main: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  head: {
    display: 'flex',
    padding: p => (p.isMobile() ? 30 : 24),
    justifyContent: p => (p.isMobile() ? 'center' : 'space-between'),
    alignItems: 'center',
    height: '80px',
  },
  tabs: {
    display: 'flex',
    height: '54px',
    marginBottom: '18px',
  },
  tab: {
    width: '50%',
    textAlign: 'center',
    paddingBottom: isDesktop() ? 17 : 13,
  },
  tbHeader: {
    display: 'flex',
    textAlign: p => (p.langCd === 'ar' ? 'right' : 'left'),
    padding: '0 24px 12px 24px',
  },
  tbHeaderLabel: {
    fontSize: 12,
    fontWeight: 'normal',
    fontFamily: 'Montserrat',
    color: '#181818',
  },
  tbRowBox: {
    display: 'flex',
    cursor: 'pointer',
    padding: isDesktop() ? '12px 24px' : '26px 24px',
    height: '75px',
    alignItems: 'center',
  },
  tbDataName: {
    fontSize: 18,
    fontWeight: '400',
    fontFamily: 'Montserrat',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  },
  tbDataStatus: {
    fontSize: 12,
    fontWeight: '500',
    fontFamily: 'Montserrat',
    color: '#2A3132',
  },
  eligiBox: {
    background: '#000000',
    color: '#FFFFFF',
    position: 'fixed',
    // eslint-disable-next-line
    top: isMobile() ? 0 : (isTablet() ? 212 : 184),
    // eslint-disable-next-line
    left: isMobile() ? 0 : (isTablet() ? 48 : 356),
    margin: 6,
    // eslint-disable-next-line
    width: isMobile() ? 'calc(100% - 12px)' : (isTablet() ? 'calc(100% - 96px - 12px)' : 'calc(100% - 128px - 290px - 16px)'),
    zIndex: 1,
  },
  oooBanner: {
    backgroundColor: '#181818',
    color: '#fff',
    display: 'flex',
    margin: 6,
    alignItems: 'center',
  },
  sharePrp: {
    bottom: 0,
    width: '100%',
  },
  viewAllLeads: {
    position: 'fixed',
    bottom: '36px',
    left: '50%',
    margin: '0 -41px',
  },
}));


const Activity = ({
  callApi, redirectTo, setShowBackBtn, onShareYourPrp,
}) => {
  const mrktCd = cookies.load('mrktCd');
  const langCd = cookies.load('langCd');
  const theme = useTheme();
  const classes = useStyles({ isMobile, langCd });

  const { setError, cleanToastBanner } = useError();

  const [prpLink, setPrpLink] = useState();
  useEffect(() => {
    const slProfleStr = sessionStorage.getItem('slProfile');
    if (slProfleStr) {
      const slProfileJSON = JSON.parse(slProfleStr);
      const { profileLink } = slProfileJSON;
      setPrpLink(profileLink);
    }
  }, []);

  const statusColors = {
    new: '#BAD9D9',
    in_progress: '#E4EDED',
    awaiting_acceptance: '#BAD9D9',
    expired: '#A2ACAE',
    pending: '#EAF6F8',
  };

  const [currentTab, setCurrentTab] = useState('new');

  const [newLeadData, setNewLeadData] = useState();
  const [inprogressLeadData, setInprogressLeadData] = useState();
  const [{ profile, dashboard }, dispatch] = useContext(HomeContext);

  const chevronRightIcon = color => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M8.59961 7.4L9.99961 6L15.9996 12L9.99961 18L8.59961 16.6L13.1996 12L8.59961 7.4Z" fill={color} />
    </svg>
  );

  const nextIcon = (
    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5.29282 3.79297C5.65326 3.43245 6.22049 3.40466 6.61281 3.70964L6.70703 3.79282L10.7075 7.79238C11.068 8.15285 11.0958 8.72013 10.7907 9.11245L10.7075 9.20667L6.70711 13.2071C6.31658 13.5976 5.68342 13.5976 5.29289 13.2071C4.93241 12.8466 4.90468 12.2794 5.2097 11.8871L5.29289 11.7929L8.586 8.499L5.29297 5.20718C4.93245 4.84674 4.90466 4.27951 5.20964 3.88719L5.29282 3.79297Z" fill={theme.palette.colors.corePink} />
    </svg>
  );

  const shareIcon = (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M11.7183 7.05125L12 7.03095V4.00195C12 3.14279 13.0119 2.68361 13.6585 3.24937L21.6585 10.2494C22.1138 10.6478 22.1138 11.3561 21.6585 11.7545L13.6585 18.7545C13.0119 19.3203 12 18.8611 12 18.0019V14.8929L11.8153 14.883C8.80455 14.7704 6.24374 16.4922 4.05019 20.1857L3.86824 20.4981C3.35947 21.3884 2 21.0274 2 20.0019C2 12.002 5.29741 7.56026 11.7183 7.05125ZM19.481 11.0019L14 6.20595V8.00195C14 8.55423 13.5523 9.00195 13 9.00195C8.02464 9.00195 5.15884 11.3643 4.28707 16.3377L4.266 16.4669L4.32812 16.3956C6.7396 13.6866 9.60493 12.5179 12.8748 12.9713L13.1644 13.0156C13.6466 13.0959 14 13.5131 14 14.0019V15.7969L19.481 11.0019Z" fill={theme.palette.colors.corePink} />
    </svg>
  );

  const [newSize, setNewSize] = useState(0);
  const [inprogressSize, setInprogressSize] = useState(0);
  const [eligiEnabled, setEligiEnabled] = useState(true);
  const [showEligiBanner, setShowEligiBanner] = useState(true);
  const [activityContent, setActivityContent] = useState();

  const [showOOO, setShowOOO] = useState(true);
  const maxNumList = parseInt((window.innerHeight - 418) / 63.5, 10) >= 1
    ? parseInt((window.innerHeight - 418) / 63.5, 10) : 1;

  const getOptOutData = async () => {
    try {
      await callApi(getOptOut()).then((res) => {
        setEligiEnabled(res.eligiEnable);
      });

      cleanToastBanner();
      return true;
    } catch (e) {
      setError(e.error);
      return false;
    }
  };

  useEffect(() => {
    getOptOutData();
  }, []);

  useEffect(() => {
    const getLeadData = async () => {
      try {
        // get new leads
        await callApi(getLeadsByStatus({
          pagination: { pageSize: 20, pageIndex: 0 },
          filters: { Status: ['new'] },
        })).then((res) => {
          if (res.records && res.records.length > 0) {
            setNewSize(res.records.length);
            setCurrentTab('new');
          }
          setNewLeadData(res);
        });

        // get in progress leads
        await callApi(getLeadsByStatus({
          pagination: { pageSize: 20, pageIndex: 0 },
          filters: { Status: ['in_progress', 'awaiting_acceptance', 'pending'] },
        })).then((res) => {
          if (res.records && res.records.length > 0) {
            setInprogressSize(res.records.length);
          }
          setInprogressLeadData(res);
          if (newSize === 0 && inprogressSize > 0 && !sessionStorage.getItem('shareModal')) {
            setCurrentTab('in_progress');
          }
        });

        cleanToastBanner();
        return true;
      } catch (e) {
        setError(e.error);
        return false;
      }
    };

    getLeadData();
  }, [newSize, inprogressSize]);

  const MAX_SAFE = 1000000000;
  const EXPIRING_TIMEOUT = 60000;
  const EXPIRING_IN_ONE_DAY = 60000 * 60 * 24;
  const msRemaining = stusEndDt => dayjs(stusEndDt) - dayjs();
  const checkTime = (stusEndDt, targetTime) => (
    !stusEndDt ? false : (msRemaining(stusEndDt) <= targetTime)
  );

  const Row = (record) => {
    const [{
      leadsContent: {
        repCard: {
          timerLabelMap,
        },
      },
    }] = useContext(HomeContext);

    // eslint-disable-next-line
    const [fadeGrey, setFadeGrey] = useState(false);

    const { data } = record;

    // eslint-disable-next-line
    const [isExpired, setIsExpired] = useState(checkTime(data.rep.stusEndDtStr, 0));
    // eslint-disable-next-line
    const [isExpiring, setIsExpiring] = useState(checkTime(data.rep.stusEndDtStr, EXPIRING_TIMEOUT));

    const statusColor = useMemo(
      () => statusColors[data.rep.stusCd],
      [isExpired, data.rep.stusCd, statusColors],
    );

    const expiringMessage = useMemo(() => (
      <React.Fragment>
        <Typography component="span" variant="body1" weight="regular" style={{ color: statusColor }}>{'<1'}</Typography>
        <Typography component="span" variant="body1" weight="regular" style={{ color: statusColor }}>{timerLabelMap.minute}</Typography>
      </React.Fragment>
    ), [timerLabelMap.minute]);

    const clockIcon = color => (
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15C11.866 15 15 11.866 15 8ZM3 8C3 5.23858 5.23858 3 8 3C10.7614 3 13 5.23858 13 8C13 10.7614 10.7614 13 8 13C5.23858 13 3 10.7614 3 8Z" fill={color} />
        <path d="M8 4C8.51284 4 8.93551 4.38604 8.99327 4.88338L9 5V7.585L10.7071 9.29289C11.0676 9.65338 11.0953 10.2206 10.7903 10.6129L10.7071 10.7071C10.3466 11.0676 9.77939 11.0953 9.3871 10.7903L9.29289 10.7071L7.29289 8.70711C7.13661 8.55083 7.0374 8.34815 7.00867 8.13144L7 8V5C7 4.44772 7.44772 4 8 4Z" fill={color} />
      </svg>
    );


    const setTimer = () => {
      const remaining = msRemaining(data.rep.stusEndDtStr);

      return setTimeout(() => {
        if (isExpiring) {
          setFadeGrey(true);
          // disable-eslint-next-line
          // console.log(fadeGrey);
          setIsExpired(true);
        } else if (remaining < EXPIRING_TIMEOUT) {
          setIsExpiring(true);
        } else {
          setTimer();
        }
      }, (Math.min(MAX_SAFE, remaining - (isExpiring ? 0 : EXPIRING_TIMEOUT))));
    };


    useEffect(() => {
      if (data.rep.stusEndDtStr) {
        const t = setTimer();
        return () => clearTimeout(t);
      }
      return () => { };
    }, [data.rep.stusEndDtStr, isExpiring, isExpired]);

    return isMobile() ? (
      <Box
        style={{ display: 'flex', flexDirection: 'column' }}
        onClick={() => {
          dispatch({ currentPage: 'leads' });
          redirectTo({
            type: 'lma', subType: 'leads', hasFooter: false, params: data.rep.leadSource === 'NRJ' ? `apptId=${data.apptId}&NRJAppt=true` : `apptId=${data.apptId}`,
          });
        }}
      >
        <Box style={{ display: 'flex', alignItems: 'center' }} mt="12px" ml="12px">
          <Typography
            className={classes.tbDataStatus}
            style={{
              background: isExpired ? '#A2ACAE' : statusColor,
              borderRadius: 10,
              padding: '4px 10px',
              textAlign: 'center',
              fontSize: 12,
              fontWeight: '500',
              fontFamily: 'Montserrat',
            }}
          >
            {data.rep.stusLabel}
          </Typography>
          <Box m="2px 0px 2px 12px" height="16px">
            {isExpired ? null : clockIcon(checkTime(data.rep.stusEndDtStr, EXPIRING_IN_ONE_DAY) ? '#851168' : '#851168')}
          </Box>
          <Box ml="6px">
            {
              // eslint-disable-next-line
              isExpired ? null : (!isExpiring ? (
                <Timer
                  formatArray={['day', 'hour', 'minute']}
                  timerLabelMap={timerLabelMap}
                  countdown={msRemaining(data.rep.stusEndDtStr)}
                  statusColor={checkTime(data.rep.stusEndDtStr, EXPIRING_IN_ONE_DAY) ? '#851168' : '#851168'}
                />
              ) : expiringMessage)
            }
          </Box>
        </Box>
        <Box ml="12px" mt="6px" mb="5px">
          <Typography variant="body2" style={{ fontSize: 14 }}>
            {
              // eslint-disable-next-line
              (['RU', 'PH', 'HU'].indexOf(mrktCd) !== -1) ? (
                mrktCd === 'RU'
                  ? [data.rep.contactDetails.surName, data.rep.contactDetails.name, data.rep.contactDetails.mddlNm].join(' ')
                  : `${data.rep.contactDetails.surName || ''} ${data.rep.contactDetails.name || ''}`
              ) : (
                `${data.rep.contactDetails.name || ''} ${data.rep.contactDetails.surName || ''}`
              )
            }
          </Typography>
        </Box>
        <Box style={{ borderBottom: 'solid 1px #E4EDED' }} />
      </Box>
    )
      : (
        <>
          <Grid
            className={classes.tbRowBox}
            container
            onClick={() => {
              dispatch({ currentPage: 'leads' });
              redirectTo({
                type: 'lma', subType: 'leads', hasFooter: false, params: data.rep.leadSource === 'NRJ' ? `apptId=${data.apptId}&NRJAppt=true` : `apptId=${data.apptId}`,
              });
              setShowBackBtn(true);
            }}
          >
            <Grid item xs={6} className={classes.tbDataName}>
              {
                // eslint-disable-next-line
                (['RU', 'PH', 'HU'].indexOf(mrktCd) !== -1) ? (
                  mrktCd === 'RU'
                    ? [data.rep.contactDetails.surName, data.rep.contactDetails.name, data.rep.contactDetails.mddlNm].join(' ')
                    : `${data.rep.contactDetails.surName || ''} ${data.rep.contactDetails.name || ''}`
                ) : (
                  `${data.rep.contactDetails.name || ''} ${data.rep.contactDetails.surName || ''}`
                )
              }
            </Grid>
            <Grid
              item
              xs={3}
              style={{
                display: 'flex', alignItems: 'center', height: '20px',
              }}
            >
              <Typography
                className={classes.tbDataStatus}
                style={{
                  background: isExpired ? '#A2ACAE' : statusColor,
                  borderRadius: 13,
                  padding: '4px 10px',
                  textAlign: 'center',
                }}
              >
                {data.rep.stusLabel}
              </Typography>
            </Grid>
            <Grid item xs={3} style={{ display: 'flex', alignItems: 'center' }}>
              {langCd === 'ar' ? (
                <>
                  <Box>
                    {
                    // eslint-disable-next-line
                    isExpired ? null : (!isExpiring ? (
                      <Timer
                        formatArray={['day', 'hour', 'minute']}
                        timerLabelMap={timerLabelMap}
                        countdown={msRemaining(data.rep.stusEndDtStr)}
                        statusColor={checkTime(data.rep.stusEndDtStr, EXPIRING_IN_ONE_DAY) ? '#851168' : '#851168'}
                      />
                    ) : expiringMessage)
                  }
                  </Box>
                  <Box mr="12px">
                    {isExpired ? null : clockIcon(checkTime(data.rep.stusEndDtStr, EXPIRING_IN_ONE_DAY) ? '#851168' : '#851168')}
                  </Box>
                </>
              )
                : (
                  <>
                    <Box mr="12px">
                      {isExpired ? null : clockIcon(checkTime(data.rep.stusEndDtStr, EXPIRING_IN_ONE_DAY) ? '#851168' : '#851168')}
                    </Box>
                    <Box>
                      {
                      // eslint-disable-next-line
                      isExpired ? null : (!isExpiring ? (
                        <Timer
                          formatArray={['day', 'hour', 'minute']}
                          timerLabelMap={timerLabelMap}
                          countdown={msRemaining(data.rep.stusEndDtStr)}
                          statusColor={checkTime(data.rep.stusEndDtStr, EXPIRING_IN_ONE_DAY) ? '#851168' : '#851168'}
                        />
                      ) : expiringMessage)
                    }
                    </Box>
                  </>
                )}
              <Box
                style={{ flexGrow: 1, textAlign: 'right', transform: langCd === 'ar' ? 'rotate(180deg)' : 'unset' }}
              >
                {chevronRightIcon('#851168')}
              </Box>
            </Grid>
          </Grid>
          <Box
            style={{ margin: '0 24px', borderBottom: 'solid 1px #E4EDED' }}
          />
        </>
      );
  };

  useEffect(() => {
    const fetchLeadContent = async () => {
      try {
        await callApi(getViewAllLeads()).then((res) => {
          dispatch({ leadsContent: res.jsonObject });
          setActivityContent(res.jsonObject.activity);
        });

        cleanToastBanner();
        return true;
      } catch ({ error }) {
        setError(error);
        return false;
      }
    };
    fetchLeadContent();
  }, []);


  const leadDataTemp = currentTab === 'new' ? newLeadData : inprogressLeadData;
  // eslint-disable-next-line
  const leadDataRecords = leadDataTemp && leadDataTemp.records && leadDataTemp.records.map((item) => {
    // eslint-disable-next-line
    item.stusEndDtStr = item.rep.stusEndDtStr;
    return item;
  }).sort((a, b) => (a.stusEndDtStr > b.stusEndDtStr ? 1 : -1));
  // eslint-disable-next-line
  const leadData = leadDataTemp && leadDataRecords && Object.assign({}, leadDataTemp, { records: leadDataRecords });

  const profileJSON = JSON.parse(profile || sessionStorage.getItem('slProfile'));
  const avatar = profileJSON.files.myPic;

  const dashboardJson = JSON.parse(dashboard || sessionStorage.getItem('dashboard'));
  const welcome = dashboardJson.dashboardInfo.headingWelcome || 'Welcome';
  const subHeading = dashboardJson.dashboardInfo.subheading || 'Share your personal page to grow your team';

  const oooInfo = dashboardJson.outOfOfficeInfo;
  const {
    enabled, beginDate, endDate, headerLabel, change, editLink,
  } = oooInfo || {};

  const isNowAfterDate = date => compareAsc(new Date(), date) === 1;
  const isNowBeforeDate = date => compareAsc(new Date(), date) === -1;

  return activityContent ? (
    <>
      {showOOO && enabled
        && !isNowBeforeDate(new Date(beginDate)) && !isNowAfterDate(new Date(endDate))
        ? (
          <Box className={classes.oooBanner}>
            <Box style={{ margin: 5 }}>
              <img alt="info" src={infoSvg} />
            </Box>
            <Box display="flex" flexGrow={1} justifyContent="center">
              <Box style={{ margin: 5 }}>
                <Typography variant="body2">
                  {`${headerLabel}`}
                </Typography>
              </Box>
              <Box
                style={{ margin: 5, cursor: 'pointer' }}
                onClick={() => redirectTo({
                  type: 'personalPage', subType: 'myPage', editPrp: editLink, hasFooter: false, params: null,
                })}
              >
                <Typography weight="bold">
                  {`${change}`}
                </Typography>
              </Box>
            </Box>
            <Box style={{ margin: 5, cursor: 'pointer' }} onClick={() => setShowOOO(false)}>
              <img alt="close" src={closeSvg} />
            </Box>
          </Box>
        )
        : null}
      <Box className={classes.main}>
        {(false && !eligiEnabled && showEligiBanner && activityContent.optOutEnabled) && (
          <Box className={classes.eligiBox}>
            <Box id="eligiTitle" display="flex">
              <Box style={{ margin: 14 }}>
                <img alt="info" src={infoSvg} />
              </Box>
              <Typography
                variant="body2"
                style={{
                  flexGrow: 1, marginTop: 15, marginRight: 12, lineHeight: '16px',
                }}
              >
                {activityContent.eligiLabel || 'You are not eligible. This campaing you will not recieve Avon appointments as few conditions were not met.'}
              </Typography>
              <Box
                style={{ margin: 12 }}
                onClick={() => setShowEligiBanner(false)}
              >
                <img alt="close" src={closeSvg} />
              </Box>
            </Box>
            <Box
              id="learnMore"
              style={{ textAlign: 'right', margin: '3px 36px 18px 0' }}
              onClick={() => redirectTo({
                type: 'learnMore', subType: null, hasFooter: false, params: null,
              })}
            >
              <Typography weight="bold" style={{ fontSize: 16 }}>{activityContent.learnMore || 'LEARN MORE'}</Typography>
            </Box>
          </Box>
        )}
        {
          isMobile() && (
            <Box id="profileInfo" style={{ display: 'flex', background: '#F6F9F9' }}>
              <Box width={46} height={46} ml="12px" mt="24px">
                <Avatar
                  className={classes.menuAvatar}
                  src={avatar}
                  alt="avatar"
                />
              </Box>
              <Box ml="20px" style={{ display: 'flex', flexDirection: 'column', flexGrow: 1 }}>
                <Box style={{ display: 'flex', marginTop: 24 }}>
                  <Box>
                    <Typography variant="body2" style={{ fontSize: 14 }}>{welcome}</Typography>
                  </Box>
                  <Box
                    style={{
                      flexGrow: 1,
                      color: theme.palette.colors.corePink,
                      display: 'flex',
                      justifyContent: 'flex-end',
                    }}
                    onClick={() => onShareYourPrp(true)}
                  >
                    <Typography variant="body2" weight="bold" style={{ fontSize: 14 }} id="activity-viewpage">{activityContent.viewPage || 'VIEW PAGE'}</Typography>
                    <Box ml="10px" mr="12px">
                      {nextIcon}
                    </Box>
                  </Box>
                </Box>
                <Box>
                  <Typography variant="body2" style={{ fontSize: 24, overflowWrap: 'anywhere', marginRight: 20 }}>
                    {
                      // eslint-disable-next-line
                      (['RU', 'PH', 'HU'].indexOf(mrktCd) !== -1) ? (
                        mrktCd === 'RU'
                          ? [profileJSON.surName, profileJSON.name, profileJSON.mddlNm].join(' ')
                          : `${profileJSON.surName || ''} ${profileJSON.name || ''}`
                      ) : (
                        `${profileJSON.name || ''} ${profileJSON.surName || ''}`
                      )
                    }
                  </Typography>
                </Box>
                <Box mt="6px" mb="24px">
                  <Typography variant="body2" style={{ fontSize: 12 }}>{subHeading}</Typography>
                </Box>
              </Box>
            </Box>
          )
        }
        <Box
          id="fixedHeader"
          style={{
            display: isMobile() ? 'unset' : 'flex',
            flexDirection: isMobile() ? 'unset' : 'column',
            position: isMobile() ? 'unset' : 'fixed',
            // eslint-disable-next-line
            width: isDesktop() ? 'calc(100% - 128px - 290px)' : isTablet() ? 'calc(100% - 96px)' : '100%',
          }}
        >
          <Box className={classes.head}>
            <Typography style={{
              fontFamily: 'Montserrat-Medium',
              fontSize: isMobile() ? 14 : 24,
              fontWeight: isMobile() ? 400 : 500,
              color: '#181818',
            }}
            >
              {activityContent.yourActivity || 'Your activity'}
            </Typography>
            {isMobile() ? null : (
              <Typography
                weight="bold"
                // eslint-disable-next-line
                style={{ fontSize: 16, cursor: 'pointer', color: ((currentTab === 'new' && newLeadData && (newLeadData.hasData === false || newLeadData.records.length === 0)) || (currentTab === 'in_progress' && inprogressLeadData && (inprogressLeadData.hasData === false || inprogressLeadData.records.length === 0))) ? theme.palette.colors.greyText : theme.palette.colors.corePink }}
                onClick={
                  // eslint-disable-next-line
                  ((currentTab === 'new' && newLeadData && (newLeadData.hasData === false || newLeadData.records.length === 0)) || (currentTab === 'in_progress' && inprogressLeadData && (inprogressLeadData.hasData === false || inprogressLeadData.records.length === 0)))
                    ? () => { }
                    : () => {
                      dispatch({ currentPage: 'leads' });
                      redirectTo({
                        type: 'lma',
                        subType: 'leads',
                        hasFooter: false,
                        params: currentTab === 'new' ? 'status=new' : 'status=in_progress&status=awaiting_acceptance&status=pending',
                      });
                    }}
                id="activity-viewall"
              >
                {activityContent.viewAll || 'VIEW ALL'}
              </Typography>
            )}
          </Box>
          <Box className={classes.tabs}>
            <Box className={classes.tab} onClick={() => setCurrentTab('new')} style={isMobile() ? { border: 'solid 1px #E4EDED', borderBottom: currentTab === 'new' ? `solid 4px ${theme.palette.colors.corePink}` : 'solid 1px #E4EDED' } : { borderBottom: currentTab === 'new' ? `solid 4px ${theme.palette.colors.corePink}` : 'solid 2px #F6F9F9' }}>
              <div
                id="activity-leads"
                style={{
                  color: currentTab === 'new' ? '#181818' : '#A2ACAE',
                  fontSize: 16,
                  fontWeight: '500',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  cursor: 'pointer',
                  fontFamily: 'Montserrat-Medium',
                }}
              >
                {activityContent.leads || 'Leads'}
                <p style={{ color: currentTab === 'new' ? theme.palette.colors.corePink : 'unset' }}>{`(${newLeadData ? newLeadData.pagination.recordCount : 0})`}</p>
              </div>
            </Box>
            <Box className={classes.tab} onClick={() => setCurrentTab('in_progress')} style={isMobile() ? { border: 'solid 1px #E4EDED', borderBottom: currentTab === 'in_progress' ? `solid 4px ${theme.palette.colors.corePink}` : 'solid 1px #E4EDED' } : { borderBottom: currentTab === 'in_progress' ? `solid 4px ${theme.palette.colors.corePink}` : 'solid 2px #F6F9F9' }}>
              <div
                id="activity-inprogress"
                style={{
                  color: currentTab === 'in_progress' ? '#181818' : '#A2ACAE',
                  fontSize: 16,
                  fontWeight: '500',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  cursor: 'pointer',
                  fontFamily: 'Montserrat-Medium',
                }}
              >
                {activityContent.inProgress || 'In Progress'}
                <p style={{ color: currentTab === 'in_progress' ? theme.palette.colors.corePink : 'unset' }}>{`(${inprogressLeadData ? inprogressLeadData.pagination.recordCount : 0})`}</p>
              </div>
            </Box>
          </Box>
          {!isMobile() && (
            <Grid container className={classes.tbHeader}>
              <Grid item xs={6}>
                <Typography
                  style={{ fontSize: 12, fontFamily: 'Montserrat', color: '#181818' }}
                >
                  {activityContent.name || 'NAME'}
                </Typography>
              </Grid>
              <Grid item xs={3}>
                <Typography style={{ fontSize: 12, ffontFamily: 'Montserrat', color: '#181818' }}>{activityContent.status || 'STATUS'}</Typography>
              </Grid>
              <Grid item xs={3}>
                <Typography style={{ fontSize: 12, fontFamily: 'Montserrat', color: '#181818' }}>{activityContent.time || 'TIME'}</Typography>
              </Grid>
            </Grid>
          )}
        </Box>
        <Box
          id="dataBox"
          style={{
            marginTop: isMobile() ? 'unset' : '170px',
            overflow: 'auto',
            // eslint-disable-next-line
            // height: isDesktop() ? window.innerHeight - (182 + 364) : window.innerHeight - (212 + 242),
          }}
        >
          {
            isMobile()
              ? (
                <Box>
                  {leadData && leadData.records.map(
                    (lead, index) => (index <= maxNumList - 1 ? <Row key={`lead-${index}`} data={lead} /> : null),
                  )}
                </Box>
              )
              : (
                <Box>
                  {leadData && leadData.records.map(
                    (lead, index) => (<Row key={`lead-${index}`} data={lead} />),
                  )}
                </Box>
              )
          }

          {
            // eslint-disable-next-line
            ((currentTab === 'new' && newLeadData && (newLeadData.hasData === false || newLeadData.records.length === 0)) || (currentTab === 'in_progress' && inprogressLeadData && (inprogressLeadData.hasData === false || inprogressLeadData.records.length === 0))) && (
              <Box mt={isMobile() ? '32px' : '24px'} mb={isMobile() ? '36px' : '42px'}>
                <Typography variant="body1" style={{ fontSize: 18, color: '#A2ACAE', textAlign: 'center' }}>
                  {activityContent.noLeads || 'No leads'}
                </Typography>
                <div id="no-lead-divider" style={{ height: 1, background: '#E4EDED', margin: '24px' }} />
              </Box>
            )}
          {
            // eslint-disable-next-line
            (isMobile() && ((currentTab === 'new' && newLeadData && newLeadData.records.length >= 1) || (currentTab === 'in_progress' && inprogressLeadData && inprogressLeadData.records.length >= 1))) && (
              <Box pt="16px" pb="16px" className={classes.viewAllLeads}>
                <Typography
                  weight="bold"
                  style={{
                    fontSize: 16,
                    color: theme.palette.colors.corePink,
                    textAlign: 'center',
                    cursor: 'pointer',
                  }}
                  onClick={
                    // eslint-disable-next-line
                    ((currentTab === 'new' && newLeadData && (newLeadData.hasData === false || newLeadData.records.length === 0)) || (currentTab === 'in_progress' && inprogressLeadData && (inprogressLeadData.hasData === false || inprogressLeadData.records.length === 0)))
                      ? () => { }
                      : () => {
                        dispatch({ currentPage: 'leads' });
                        redirectTo({
                          type: 'lma',
                          subType: 'leads',
                          hasFooter: false,
                          params: currentTab === 'new' ? 'status=new' : 'status=in_progress&status=awaiting_acceptance&status=pending',
                        });
                      }}
                  id="activity-viewall"
                >
                  {activityContent.viewAll || 'VIEW ALL'}
                </Typography>
              </Box>
            )}
          {
            // eslint-disable-next-line
            ((currentTab === 'new' && newLeadData && (newLeadData.hasData === false || newLeadData.records.length === 0)) || (currentTab === 'in_progress' && inprogressLeadData && (inprogressLeadData.hasData === false || inprogressLeadData.records.length === 0))) && (
              <Box id="sharePrp" className={classes.sharePrp}>
                {isMobile()
                  ? (
                    <Box
                      style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                      onClick={() => {
                        onShareYourPrp(true);
                        // share({ url: prpLink })
                      }}
                    >
                      <Typography weight="bold" style={{ color: theme.palette.colors.corePink }}>
                        {activityContent.shareYourPrp || 'SHARE YOUR PAGE'}
                      </Typography>
                      <Box ml="10px">
                        {shareIcon}
                      </Box>
                    </Box>
                  )
                  : (
                    <Box
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        flexDirection: 'row',
                        // eslint-disable-next-line
                        alignItems: isDesktop() ? 'center' : 'unset',
                      }}
                    >
                      {false ? (
                        <Box m={3}>
                          <InlineShareButtons
                            config={{
                              alignment: 'center', // alignment of buttons (left, center, right)
                              color: 'social', // set the color of buttons (social, white)
                              enabled: true, // show/hide buttons (true, false)
                              font_size: 16, // font size for the buttons
                              labels: 'cta', // button labels (cta, counts, null)
                              language: 'en', // which language to use (see LANGUAGES)
                              networks: [ // which networks to include (see SHARING NETWORKS)
                                'blogger',
                                'delicious',
                                'digg',
                                'email',
                                'facebook',
                                'flipboard',
                                'linkedin',
                                'livejournal',
                                'mailru',
                                'meneame',
                                'messenger',
                                'oknoklassniki',
                                'pinterest',
                                'print',
                                'reddit',
                                'sharethis',
                                'sms',
                                'stumbleupon',
                                'telegram',
                                'tumblr',
                                'twitter',
                                'vk',
                                'wechat',
                                'weibo',
                                'whatsapp',
                                'xin',
                              ],
                              padding: 12, // padding within buttons (INTEGER)
                              radius: 4, // the corner radius on each button (INTEGER)
                              show_total: false,
                              size: 40, // the size of each button (INTEGER)

                              // OPTIONAL PARAMETERS
                              url: prpLink, // (defaults to current url)
                            }}
                          />
                        </Box>
                      )
                        : (
                          <Box mr="5px">
                            <Button
                              priority="secondary"
                              name="share-your-prp"
                              id="share-your-prp"
                              onClick={() => {
                                onShareYourPrp(true);
                                // share({ url: prpLink })
                              }}
                            >
                              {activityContent.shareYourPrp || 'SHARE YOUR PRP'}
                            </Button>
                          </Box>
                        )}
                      { !activityContent.startApptHide && (
                        <Box ml={langCd === 'ar' ? 'unset' : '5px'} mr={cookies.load('langCd') === 'ar' ? '5px' : 'unset'}>
                          <Button
                            priority="primary"
                            name="start-new-appt"
                            id="start-new-appt"
                            onClick={
                              () => {
                                dispatch({ currentPage: 'appointment' });
                                redirectTo({
                                  type: 'appointment', subType: null, hasFooter: false, params: null, editPrp: null, entry: 'home_page',
                                });
                              }}
                          >
                            {activityContent.startAppt || 'START AN APPOINTMENT'}
                          </Button>
                        </Box>
                      )}
                    </Box>
                  )}
              </Box>
            )
          }
        </Box>
      </Box>
    </>
  ) : null;
};

Activity.propTypes = {
  callApi: func.isRequired,
  redirectTo: func.isRequired,
  setShowBackBtn: func,
  onShareYourPrp: func,
};


export default Activity;
